export default {
  page: {
    title: 'Special character remover',
    subtitle: 'Tools',
  },
  card: {
    title: 'Special character remover',
  },
  form: {
    text: {
      label: 'Original text',
      placeholder: 'Paste your text here...',
    },
    keepPunctuation: {
      label: 'Keep punctuation',
    },
    keepLineBreaks: {
      label: 'Keep line breaks',
    },
    result: {
      label: 'Clean text',
    },
  },
  alert: {
    textCopied: 'Text copied!',
  },
};
